export default __webpack_public_path__ + "static/media/mission.5835b269.jpg";